import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { baseUrl } from "../../../helper/urls";
import { Icon } from "@iconify/react"; // Iconify import

const HelpAndSupport = () => {
  const { token } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState("Tutorials");
  const [faqsData, setFaqsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const youtubePlaylistUrl =
    "https://www.youtube.com/embed/videoseries?list=PLStZlz6edVrOtR7EpRLZZeDePe2JUA0wy";

  const pptUrl =
    "https://view.officeapps.live.com/op/embed.aspx?src=http://app.dreamdor.com/dreamdor_ppt.pptx";

  const fetchFaqsList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/api/faq/user/student`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const updatedData = (response.data.data || []).map((item) => ({
        ...item,
        isOpen: false,
      }));
      setFaqsData(updatedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "FAQs") {
      fetchFaqsList();
    }
  }, [activeTab]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Sidebar Tabs */}
      <div
        style={{
          width: "250px",
          backgroundColor: "#f9fafb",
          borderRight: "1px solid #e5e7eb",
          padding: "15px",
        }}
      >
        {["Tutorials", "Slide Deck", "FAQs"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              width: "100%",
              textAlign: "left",
              padding: "12px 16px",
              borderRadius: "8px",
              marginBottom: "8px",
              backgroundColor: activeTab === tab ? "#124178" : "transparent",
              color: activeTab === tab ? "white" : "#124178",
              border: "none",
              cursor: "pointer",
              outline: "none",
              transition:
                "background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",
              boxShadow:
                activeTab === tab ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none",
            }}
            onMouseOver={(e) => {
              if (activeTab !== tab)
                e.currentTarget.style.backgroundColor = "#e5e7eb";
            }}
            onMouseOut={(e) => {
              if (activeTab !== tab)
                e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, padding: "15px", overflowY: "auto" }}>
        {activeTab === "Tutorials" && (
          <div
            style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
              src={youtubePlaylistUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {activeTab === "Slide Deck" && (
          <div
            style={{ position: "relative", paddingBottom: "75%", height: 0 }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
              src={pptUrl}
              title="Slide Deck Presentation"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {activeTab === "FAQs" && (
          <div>
            <h4 style={{ color: "#124178", marginBottom: "20px" }}>
              Frequently Asked Questions
            </h4>
            {loading ? (
              <p>Loading FAQs...</p>
            ) : faqsData.length === 0 ? (
              <p>No FAQs found.</p>
            ) : (
              faqsData.map((faq, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: "10px",
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    overflow: "hidden",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <button
                    onClick={() =>
                      setFaqsData((prevData) =>
                        prevData.map((item, i) =>
                          i === index
                            ? { ...item, isOpen: !item.isOpen }
                            : { ...item, isOpen: false }
                        )
                      )
                    }
                    style={{
                      width: "100%",
                      textAlign: "left",
                      padding: "12px 16px",
                      backgroundColor: "#e5e7eb",
                      border: "none",
                      outline: "none",
                      fontWeight: "600",
                      cursor: "pointer",
                      color: "#111827",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>{faq.question}</span>
                    <Icon
                      icon={faq.isOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                      width="24"
                      height="24"
                      style={{ marginLeft: "10px", color: "#4b5563" }}
                    />
                  </button>
                  {faq.isOpen && (
                    <div style={{ padding: "12px 16px", color: "#4b5563" }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpAndSupport;
